
import {useState} from "react";

const useOrderValidate = () => {
    const [personInfo, setPersonInfo] = useState({
        name: '',
        surname:'',
        email:'',
        phone:'',
        projectName:'',
        address: '',
        messageText:''
    })
    const [errorText, setErrorText] = useState({
        name: '',
        email: '',
        phone:'',
        projectName:'',
        address: '',
    })

    const validateMail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

    const validation = () => {
        let validate = true
        let errorString = {
            name: '',
            email: '',
            phone: '',
            projectName:'',
            address: '',
        }
        if (!personInfo.name.trim().length) {
            validate = false
            errorString.name = "Fill in the required FirstName"
        }
        if (!personInfo.email.trim().length) {
            validate = false
            errorString.email = "Fill in the required Email Address"

        }
        else if (!validateMail.test(personInfo.email)) {
            validate = false
            errorString.email = "Fill in the email"
        }
        if (!personInfo.phone.trim().length) {
            validate = false
            errorString.phone = "Fill in the required Phone Number"

        }
        else if(personInfo.phone && personInfo.phone.length < 9){
            validate = false
            errorString.phone = "Fill in the required Phone Number"

        }

        if (!personInfo.address.trim().length) {
            validate = false
            errorString.address = "Fill in the required address"

        }
        if (!personInfo.projectName.trim().length ) {
            validate = false
            errorString.projectName = "Fill in the required Name"
        }
        setErrorText(errorString)
        return validate
    }

    return {validation, personInfo, setPersonInfo, errorText, setErrorText}
}

export default useOrderValidate